'use client';
import type { Post } from '@/interfaces/post';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@dolcevia/ui/components/ui/pagination';
import { parseAsInteger, useQueryState } from 'nuqs';
import { Filter } from '../../../../components/filter';
import { PostPreview } from './post-preview';

type Props = {
  isFrench: boolean;
  allCategories: string[];
  postsToDisplay: Post[];
  totalPages: number;
};
export function Stories({
  isFrench,
  allCategories,
  postsToDisplay,
  totalPages,
}: Props) {
  const [, setCategory] = useQueryState('category', {
    defaultValue: 'all',
    shallow: false,
  });
  const [page, setPage] = useQueryState(
    'page',
    parseAsInteger.withDefault(0).withOptions({
      shallow: false,
    }),
  );

  return (
    <>
      <div className="flex justify-between">
        <div className="flex">
          <Filter
            setCategory={(value) => {
              setCategory(value);
              setPage(0);
            }}
            items={[
              { value: 'all', label: 'Tous' },
              ...allCategories.map((category) => ({
                value: category,
                label: category.charAt(0).toUpperCase() + category.slice(1),
              })),
            ]}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 pt-6">
        {postsToDisplay.map((post, index) => (
          <div key={index} className="grip gap-4">
            <PostPreview
              key={post.slug}
              title={isFrench ? post.title : post.title_en}
              coverImage={post.coverImage}
              date={post.date}
              author={post.author}
              slug={post.slug}
              excerpt={isFrench ? post.excerpt : post.excerpt_en}
              type={post.type}
            />
          </div>
        ))}
      </div>
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              href="#"
              onClick={() => {
                if (page === 0) return;
                setPage(page - 1);
              }}
            />
          </PaginationItem>
          {Array.from({ length: totalPages }).map((_, index) => (
            <PaginationItem key={index}>
              <PaginationLink
                href="#"
                onClick={() => setPage(index)}
                isActive={page === index}
              >
                {index + 1}
              </PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem>
            <PaginationNext
              href="#"
              onClick={() => {
                if (page === totalPages - 1) return;
                setPage(page + 1);
              }}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </>
  );
}
